export default "__VITE_ASSET__0e7a44a2__"